import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Typography
} from '@mui/material';

const CB_BATCH_BULK_DENSITY_HEADERS = [
    'Project ID',
    'Batch ID',
    'CB ID',
    'Bucket Size (gal)',
    'Empty Bucket Weight (lbs)',
    'Hot Coals Bucket Weight (lbs)',
    'Bulk Density',
    'Unit'
]

export default function CbBatchBulkDensity({ bulkDensity }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">Batch Bulk Density</Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {CB_BATCH_BULK_DENSITY_HEADERS.map((header) => (
                                <TableCell
                                    key={header}
                                    align='left'>
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bulkDensity?.map((bd, index) => (
                            <TableRow key={index}>
                                <TableCell align="left">{bd.projectId}</TableCell>
                                <TableCell align="left">{bd.batchId}</TableCell>
                                <TableCell align="left">{bd.cbId}</TableCell>
                                <TableCell align="left">{bd.bucketSize}</TableCell>
                                <TableCell align="left">{bd.emptyBucketWeight}</TableCell>
                                <TableCell align="left">{bd.hotCoalsWeight}</TableCell>
                                <TableCell align="left">{bd.bulkDensity.toFixed(3)}</TableCell>
                                <TableCell align="left">{bd.unit}</TableCell>
                            </TableRow>
                        )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
